import { memo } from 'react';

import { Checkbox, TruncateText } from '@mint-lib/tw-components';
import { ComboboxItem } from '@mint-lib/tw-components/patterns';

type Props = {
  value: string;
  label: string;
  selected: boolean;
  size: number;
  start: number;
  onToggle: (value: string) => void;
};

const OptionRow = memo(
  ({ value, label, selected, size, start, onToggle }: Props) => (
    <ComboboxItem
      className="absolute top-0 left-0 w-full min-w-0 grid-cols-[auto_minmax(0,1fr)]"
      value={value}
      keywords={[label]}
      selected={selected}
      onSelect={() => onToggle(value)}
      style={{ height: `${size}px`, transform: `translateY(${start}px)` }}
      data-dd-action-name="Multi select: toggle option"
    >
      <Checkbox className="pointer-events-none" checked={selected} />
      <TruncateText>
        <p className="min-w-0">{label}</p>
      </TruncateText>
    </ComboboxItem>
  ),
);

OptionRow.displayName = 'OptionRow';

export { OptionRow };
